import { Box, Divider, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../core/hooks/useStore";
import { RootState } from "../../../../core/store/store";
import HeadlinePigLogo from "../headline-pig-logo.png";
import { HeadlineData } from "../headline-pig.slice";
import HeadlinePigResultsTable from "./results-table";

const HeadlinePigResultsPDF = (props: any) => {
  const dispatch = useAppDispatch();
  const toolData = useSelector((state: RootState) => state.headlinePig);
  const currentDate = new Date().toLocaleDateString();
  return (
    <>
      {" "}
      <Stack sx={{ padding: 4, margin: 2, backgroundColor: "#fff" }}>
        <Stack flexDirection="row" alignItems="center">
          <Box>
            <Stack flexDirection="row" alignItems="baseline">
              <Typography
                variant="h4"
                component="h4"
                sx={{ fontWeight: "bold" }}
              >
                Headline Analysis Report
              </Typography>
              <Typography variant="subtitle1" sx={{ px: 3 }}>
                {currentDate}
              </Typography>
            </Stack>
            <Typography
              variant="subtitle1"
              sx={{ marginBottom: 2, color: "gray" }}
            >
              This is a real headline assessment considering various market
              factors.
            </Typography>
          </Box>
          <div style={{ flexGrow: 1 }}></div>
          <Box sx={{ mx: 2, my: 2 }}>
            <img src={HeadlinePigLogo} alt="Headline Pig Pro" width={"200px"} />
          </Box>
        </Stack>
        <Divider
          sx={(theme) => {
            return {
              height: "3px",
              mb: 3,
              width: "100%",
              background: theme.palette.primary.main,
            };
          }}
        />
        <Typography
          variant="h5"
          component="h5"
          sx={(theme) => {
            return {
              color: theme.palette.primary.main,
              my: 3,
            };
          }}
        >
          Search Term: {(toolData.tool.data?.data as HeadlineData).niche}
        </Typography>
        <HeadlinePigResultsTable hideButtons />
      </Stack>
    </>
  );
};

export default HeadlinePigResultsPDF;
